import { buildHeadings, headingFieldCount, initialOpenHeadings } from '../headings';

describe('headings', () => {
  const groups = {
    general: { name: 'General', order: 100 },
    campground: { name: 'Campground', order: 300 },
    place_access: { name: 'Access & availability', parent: 'general', order: 110 },
    campground_sites: { name: 'Sites', parent: 'campground', order: 310 },
    campground_rules: { name: 'Rules', parent: 'campground', order: 360 }
  };

  const sections = [
    { sectionId: 'campground_rules', sectionTitle: 'Rules', parent: 'campground', order: 360, attributes: [1, 2] },
    { sectionId: 'place_access', sectionTitle: 'Access & availability', parent: 'general', order: 110, attributes: [1] },
    { sectionId: 'campground_sites', sectionTitle: 'Sites', parent: 'campground', order: 310, attributes: [1, 2, 3], mostRelevant: true }
  ];

  describe('buildHeadings', () => {
    it('orders headings by the group order, not the order sections arrive in', () => {
      expect(buildHeadings(sections, groups).map((h) => h.name)).toEqual(['General', 'Campground']);
    });

    it('orders the sections within a heading', () => {
      const campground = buildHeadings(sections, groups)[1];

      expect(campground.sections.map((s) => s.sectionTitle)).toEqual(['Sites', 'Rules']);
    });

    it('takes the heading name from the group registry', () => {
      expect(buildHeadings(sections, groups)[0].name).toBe('General');
    });

    it('falls back to the key when the registry has no entry', () => {
      const orphan = [{ sectionId: 'x', parent: 'nowhere', attributes: [] }];

      expect(buildHeadings(orphan, groups)[0].name).toBe('nowhere');
    });

    it('ignores a section with no heading', () => {
      const loose = [{ sectionId: 'loose', attributes: [] }];

      expect(buildHeadings(loose, groups)).toEqual([]);
    });

    it('tolerates no sections at all', () => {
      expect(buildHeadings([], groups)).toEqual([]);
      expect(buildHeadings(undefined, undefined)).toEqual([]);
    });
  });

  describe('initialOpenHeadings', () => {
    it('opens only the heading holding the most relevant sections', () => {
      expect(initialOpenHeadings(buildHeadings(sections, groups))).toEqual({
        general: false,
        campground: true
      });
    });

    it('opens the first heading when nothing is marked relevant', () => {
      const none = sections.map((s) => ({ ...s, mostRelevant: false }));

      expect(initialOpenHeadings(buildHeadings(none, groups))).toEqual({
        general: true,
        campground: false
      });
    });

    it('tolerates no headings', () => {
      expect(initialOpenHeadings([])).toEqual({});
    });
  });

  describe('headingFieldCount', () => {
    it('totals the fields across a heading sections', () => {
      expect(headingFieldCount(buildHeadings(sections, groups)[1])).toBe(5);
    });
  });
});
